'use strict';

var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('materialize-css');
require('slick-carousel');
require('sweetalert');
require('./contact');
require('./register');

let lazyImages = [...document.querySelectorAll('.lazy')];
let instagramFt=true;

function lazyLoad() {
    lazyImages.forEach(image => {
        if(elementVisible(image)){
            image.src = image.dataset.src;
            image.onload = () => image.classList.add('loaded');
        }
    });
    if($('.sectionInstagram').length>=1){
        if(elementVisible($('.sectionInstagram')[0])){
            if(instagramFt){
                instagramFt=false;
                //instagramGet();
            }
        }
    }
}

window.addEventListener('scroll', _.throttle(lazyLoad, 16));
window.addEventListener('resize', _.throttle(lazyLoad, 16));

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            lazyLoad();
        },0);
    }
    window.load = cargar();
    $('.modal').modal({
        dismissible: false,
    });
    $('.sidenav').sidenav({
        edge: 'left',
    });
});
$('.header .menu').click(function () {
    $('.sidenav').sidenav('open');
});
$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});
$('.feria').click(function () {
    $('html, body').animate({
        scrollTop: $('#feria').offset().top - 100
    }, 500);
});
$('.exhibitors').click(function () {
    $('html, body').animate({
        scrollTop: $('#exhibitors').offset().top - 100
    }, 500);
});
$('.visits').click(function () {
    $('html, body').animate({
        scrollTop: $('#visits').offset().top - 100
    }, 500);
});
$('.agend').click(function () {
    $('html, body').animate({
        scrollTop: $('#agend').offset().top - 100
    }, 500);
});
function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}

function instagramGet() {
    var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
    $.getJSON(URL_API_INSTAGRAM,function(data) {
        var i = 1;
        $('.instragramImages').html("");
        $.each(data.data, function (item, value) {
            if (i <= 8) {
                $('.instragramImages').append('' +
                    '<div class="col s6 m4 l3 col-instagram">' +
                    '<a target="_blank" href="' + data.data[item].link + '">' +
                    '   <div class="containerInstagram">' +
                    '       <div class="img">'+
                    '           <img src="' + value.images.low_resolution.url + '" alt="">' +
                    '       </div>'+
                    '   </div>' +
                    '</a>' +
                    '</div>');
            }
            i++;
        });
    });
}

$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 25) {
            $('.header').css('visibility','hidden');
            $('.header_2').css('visibility','inherit');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 25) {
                $('.header').css('visibility','inherit');
                $('.header_2').css('visibility','hidden');
            }
        }
    }
});

$('.sectionExhibitors .element-1 .img').css('height',$('.sectionExhibitors .element-1').css('height'));
$('.sectionExhibitors .element-2 .img').css('height',$('.sectionExhibitors .element-2').css('height'));
$('.sectionExhibitors .element-3 .img').css('height',$('.sectionExhibitors .element-3').css('height'));
$('.sectionExhibitors .element-4 .img').css('height',$('.sectionExhibitors .element-4').css('height'));


$('#sliderGalery').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 4000,
    swipe: true,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    prevArrow: $('.sectionGalery .arrowLeft'),
    nextArrow: $('.sectionGalery .arrowRight'),
    lazyLoad: 'ondemand',
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});

var countDownDate = new Date(""+date_fair+" 08:00:00").getTime();

var x = setInterval(function() {

    var now = new Date().getTime();

    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    $('.sectionCountdown .days').html(days);
    $('.sectionCountdown .hours').html(hours);
    $('.sectionCountdown .minutes').html(minutes);
    $('.sectionCountdown .seconds').html(seconds);
    // If the count down is over, write some text
    if (distance < 0) {
        clearInterval(x);
        $('.sectionCountdown .days').html('0');
        $('.sectionCountdown .hours').html('0');
        $('.sectionCountdown .minutes').html('0');
        $('.sectionCountdown .seconds').html('0');
    }
}, 0);

$('.header .contact,#mobile_menu .contact').click(function () {
   $('#modalContact').modal('open');
});

$('.header .register,#mobile_menu .register,.inscripcion').click(function () {
    $('#modalRegister').modal('open');
    setInterval(function () {
        $('.modalRegister .rowOne .img').css('height',$('.modalRegister .rowOne').css('height'));
    },100);
});

$('.sectionDemo .rowOne iframe').css('height',$('.sectionDemo .rowOne').css('height'));
